import { FC } from "react";
import { Tabs } from "@rothoblaas/design-system";
import useI18n from "../../../../hooks/useTranslations";
import AdminSubstructureFamilies from "./AdminSubstructureFamilies";
import AdminSubstructureMaterialClasses from "./AdminSubstructureMaterialClasses";
import AdminSubstructureMaterials from "./AdminSubstructureMaterials";
import AdminSubstructures from "./AdminSubstructures";

const AdminSubstructuresTabs: FC = () => {
  const i18n = useI18n();

  return (
    <Tabs.SubTab>
      <Tabs
        urlParameter="substructures_tab"
        tabs={[
          { title: i18n.translation.deckDesignerModule.substructures.plural },
          { title: i18n.translation.deckDesignerModule.substructureFamilies.plural },
          { title: i18n.translation.deckDesignerModule.substructureMaterials.plural },
          { title: i18n.translation.deckDesignerModule.substructureMaterialClasses.plural },
        ]}
        contents={[
          <AdminSubstructures />,
          <AdminSubstructureFamilies />,
          <AdminSubstructureMaterials />,
          <AdminSubstructureMaterialClasses />,
        ]}
      />
    </Tabs.SubTab>
  );
};

export default AdminSubstructuresTabs;
